export const getRatingText = userReviewRating => {
  let ratingDisclaimer = '';
  switch (userReviewRating) {
    case 1:
      ratingDisclaimer = 'Ужасный магазин!';
      break;
    case 2:
      ratingDisclaimer = 'Плохой магазин!';
      break;
    case 3:
      ratingDisclaimer = 'Обычный магазин!';
      break;
    case 4:
      ratingDisclaimer = 'Хороший магазин!';
      break;
    case 5:
      ratingDisclaimer = 'Отличный магазин!';
      break;
    default:
      ratingDisclaimer = 'Отличный магазин';
  }
  return ratingDisclaimer;
};
